'use strict';

function adComponentDropdownToggle() {
	$(document).on('click', '.ad-component_dropdown .ad-component_dropdown--trigger', function() {
		if ($(this).hasClass('ad-component_dropdown--is-active')) {
			$(this).removeClass('ad-component_dropdown--is-active');
		} else {
			$('.ad-component_dropdown .ad-component_dropdown--is-active').removeClass('ad-component_dropdown--is-active');
			$(this).addClass('ad-component_dropdown--is-active');
		}
	});
	$(document).on('click', function(e) {
		if (!$(e.target).is('.ad-component_dropdown .ad-component_dropdown--trigger')) {
			$('.ad-component_dropdown .ad-component_dropdown--is-active').removeClass('ad-component_dropdown--is-active');
		}
	});
}

module.exports = [
	'<style>',
	'.ad-component_dropdown > .ad-component_list {',
	'display: none;',
	'}',
	'.ad-component_dropdown .ad-component_dropdown--is-active ~ .ad-component_list {',
	'display: block;',
	'}',
	'</style>',
	'<script>',
	'(',
	adComponentDropdownToggle.toString(),
	')();',
	'</script>'
].join('\n');




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/functions/dropdown-click-function.tpl.js
// module id = 37
// module chunks = 0